import appapi from "../api/apiClient";

const uploadFileToS3 = async (file) => {
  const exts = file.name.split('.');
  const ext = exts[exts.length - 1];
  const key = `${Date.now()}.${ext}`;
  return new Promise(async (resolve, reject) => {
    const signedUrlResult = await appapi.post('/s3/signedUrl', {
      fileName: key,
      contentType: file.type,
    });
    if (signedUrlResult.ok) {
      const signedUrl = signedUrlResult.data.url;
      fetch(signedUrl, { method: 'PUT', body: file })
        .then((res) => {
          if (res.ok) {
            resolve(signedUrlResult.data.key)
          } else {
            reject('Failed to upload')
          }
        })
        .catch((error) => {
          reject('Failed to upload')
        });
    } else {
      reject('Failed to upload')
    }
  })
}

export default uploadFileToS3